import {
  LOAN_APPLICATION_USER_VERIFY_START,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
} from './../actions/types'

const INIT_STATE = {
  showVerifyWait: false,
  showVerifyError: false,
}

const verifyIdentity = (state=INIT_STATE, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_USER_VERIFY_START:
      return {
        ...state,
        showVerifyWait: true,
        showVerifyError: false,
      }
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
      return {
        ...state,
        showVerifyWait: false,
        showVerifyError: false,
      }
    case LOAN_APPLICATION_USER_VERIFY_FAILURE:
    return {
      ...state,
      showVerifyWait: false,
      showVerifyError: true,
    }
    default:
      return state
  }
}

export default verifyIdentity;
